// Render wrapper used by ListPlugin's `render.belowNodes`. Plate's v53 list
// model is indent-based: any block can carry `listStyleType` + `indent` and
// this wrapper paints the surrounding <ul>/<ol> + <li>.
// Simplified from Plate's reference BlockList (todo/check items deferred).

export const BlockList: any = (props: any) => {
    if (!props.element?.listStyleType) return undefined;
    return (innerProps: any) => <List {...innerProps} />;
};

const ORDERED = ['decimal', 'decimal-leading-zero', 'lower-roman', 'upper-roman', 'lower-alpha', 'upper-alpha'];
const BULLET_CYCLE = ['disc', 'circle', 'square'];
const NUMBERED_CYCLE = ['decimal', 'lower-alpha', 'lower-roman'];

function isOrderedListStyle(listStyleType: string) {
    return ORDERED.includes(listStyleType);
}

// Cycle the marker style by indent depth so nested levels read as a
// hierarchy — disc → circle → square for bullets, 1. → a. → i. for numbers.
// The stored listStyleType stays as-is on the node; we only swap the
// RENDERED marker. Avoids touching the save format.
function styleByIndent(base: string, indent: number | undefined): string {
    const depth = Math.max(0, (indent ?? 1) - 1);
    if (BULLET_CYCLE.includes(base)) {
        return BULLET_CYCLE[depth % BULLET_CYCLE.length];
    }
    if (NUMBERED_CYCLE.includes(base)) {
        return NUMBERED_CYCLE[depth % NUMBERED_CYCLE.length];
    }
    return base;
}

function List(props: any) {
    const { listStart, listStyleType, indent } = props.element;
    const effectiveStyle = styleByIndent(listStyleType, indent);
    const Tag = isOrderedListStyle(listStyleType) ? 'ol' : 'ul';
    // padding: 0 — the `<p>` inside already carries the left indent from
    // IndentPlugin; standard <ul>'s 40px padding-left would double-indent.
    // margin handled by CSS in PlateEditor.module.scss: zero between
    // consecutive list wrappers, breathing room before the next block.
    return (
        <Tag style={{ listStyleType: effectiveStyle, padding: 0 }} start={listStart}>
            <li>{props.children}</li>
        </Tag>
    );
}
